// extracted by mini-css-extract-plugin
export default {"pieceContainer":"Piece_pieceContainer__9H7ON","pieceImage":"Piece_pieceImage__7KCTT","rotated":"Piece_rotated__+JpwM"};